<template>
  <div>
    <top-card current="MakePayment"
              :cover-type="coverType"
              :free-benefits="data.quoteInfo.freeBenefits"/>
    <div class="tw-flex tw-justify-center tw-justify-items-center tw-my-8">
      <back-nav :to="$route.name === 'InstalmentPayment' ? 'Instalments' : 'PolicyReview'" />
    </div>
    <v-card v-if="false" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
      <p class="c-blue-text tw-font-bold tw-px-0 md:tw-px-10">{{ data.quoteInfo.payPercentage === 100 ? 'Full Payment' : 'Instalment Payment' }}</p>
      <div class="tw-w-full tw-flex">
        <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
          <div class="tw-flex tw-px-2 md:tw-px-10 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400">
            <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
            <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8"><span v-html="data.quoteInfo.pageTitle"></span></h3>
          </div>
          <template v-if="scanObject(data, 'quoteInfo.coverType') === 'Bima Bamba<br> Insurance Cover'">
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">
                {{ formatDateToMonth(scanObject(data, 'quoteInfo.paymentSchedule.0.dueDate'))  }}
                Instalment
              </h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">
                Kshs. {{ scanObject(data, 'payment.payableAmount')  | formatNum }}
              </h3>
            </div>
          </template>
          <template v-else-if="scanObject(data, 'quoteInfo.coverType.productCode') === 702">
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">1st Instalment</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ payableAmountPremium | formatNum }}</h3>
              <h4 class="c-blue-text tw-font-bold tw-text-sm">
                Ksh. {{ payableAmountPremium | formatNum }} per month for the following 11 months
              </h4>
            </div>
          </template>
          <template v-else>
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
              <h1 class="tw-w-full c-light-blue-text tw-font-bold tw-text-5xl md:tw-text-6xl">{{ data.quoteInfo.payPercentage }}%</h1>
              <p class="tw-w-full c-light-blue-text tw-text-sm md:tw-text-base">of the sum insured</p>
            </div>
            <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">{{ data.quoteInfo.payPercentage === 100 ? 'Total Annual' : 'Instalment' }} Premium</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ data.payment.payableAmount | formatNum }}</h3>
            </div>
          </template>
        </div>
      </div>
    </v-card>

    <v-card class="tw-mt-5 md:tw-mt-16 tw-pb-10">
      <div class="tw-px-4 md:tw-px-8">
        <card-title icon="mdi-cash">Choose your Mode of payment</card-title>
      </div>
      <div class="tw-mx-10 tw-mt-16 tw-mb-10">
        <premium-amount
            :premium-amount="this.data.payment.payableAmount"
        >Premium Payment</premium-amount>
      </div>
      <!-- Payment Options Section -->
      <div class="payment-options tw-flex tw-justify-center tw-gap-6 tw-mb-8 tw-w-full">
        <button
            class="payment-btn tw-px-6 md:tw-px-10 tw-py-3 tw-rounded-xl tw-font-semibold tw-shadow"
            :class="currentTab === 'stk' ? 'payment-btn-active' : 'payment-btn-inactive'"
            @click="setCurrentTab('stk')">
            <img :src="currentTab === 'stk'? '/icons/mpesa_express_white.svg': '/icons/mpesa_express_gray.svg'"  alt="">
        </button>
        <button
            class="payment-btn tw-px-6 md:tw-px-10 tw-py-3 tw-rounded-xl tw-font-semibold tw-shadow"
            :class="currentTab === 'paybil' ? 'payment-btn-active' : 'payment-btn-inactive'"
            @click="setCurrentTab('paybil')">
          <img :src="currentTab === 'paybil'? '/icons/paybill_white.svg': '/icons/paybill_gray.svg'"  alt="">
        </button>
        <button
            class="payment-btn tw-px-6 md:tw-px-10 tw-py-3 tw-rounded-xl tw-font-semibold tw-shadow"
            :class="currentTab === 'card' ? 'payment-btn-active' : 'payment-btn-inactive'"
            @click="setCurrentTab('card')">
          <img :src="currentTab === 'card'? '/icons/card_white.svg': '/icons/card_gray.svg'" alt="">
        </button>
      </div>

      <div class="tw-flex tw-justify-center tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
        <div v-if="!paymentInitiated" class="tw-w-full md:tw-w-8/12">
          <!-- M-Pesa Express Tab -->
          <div v-if="currentTab === 'stk'">
            <v-card class="tw-flex tw-justify-center" flat>
             <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
               <p class="c-blue-text tw-text-center">Enter the Phone Number to pay from</p>
               <v-form v-model="stkValid">
                 <v-text-field v-model="form.customerPhoneNumber" type="text" label="Phone Number" class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4" :rules="[required('Phone Number'), mobileFormat()]"></v-text-field>
                 <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                   <v-btn block large
                          color="secondary"
                          class="my-3 "
                          :loading="loading"
                          :disabled="!stkValid"
                          @click="requestSTK"
                   >
                     Pay
                   </v-btn>
                 </v-card-actions>
               </v-form>
             </div>
            </v-card>
          </div>

          <!-- Paybill Tab -->
          <div v-if="currentTab === 'paybil'">
            <v-card class="tw-flex tw-justify-center" flat>
              <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
                <p class="c-blue-text">From your phone;</p>
                <ul class="tw-mt-4">
                  <li>Go to SIM Toolkit Menu/Mpesa App</li>
                  <li>Select Mpesa</li>
                  <li>Select Lipa Na Mpesa</li>
                  <li>Select Pay Bill</li>
                  <li>Enter Business No: <strong>511600</strong></li>
                  <li>Enter Account No: <strong>{{ data.payment.accountReference.replace(' ', '') }}</strong></li>
                  <li>Enter Amount: KSH. <strong>{{ data.payment.payableAmount | formatNum }}</strong></li>
                </ul>
                <p class="c-blue-text tw-mt-4">Enter the transaction code you received from MPESA</p>
                <v-form v-model="isFilled">
                  <v-text-field id="mpesaRef" v-model="mpesaRef" :rules="[required('Mpesa Reference No')]" type="text" label="Transaction Code" class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4" v-uppercase></v-text-field>
                  <v-card-actions class="col-sm-6 offset-sm-3 tw-mt-5 tw-pb-8">
                    <v-btn block large
                           color="secondary"
                           class="my-3 "
                           :loading="paybillLoading"
                           @click="queryMpesaPaybill"
                           :disabled="!isFilled"
                    >
                      Confirm Payment
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </div>
            </v-card>
          </div>

          <!-- Card Tab -->
          <div v-if="currentTab === 'card'">
            <v-card class="tw-flex tw-justify-center" flat>
              <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8"
                style="color: #114CAC;">
                <div class="tw-flex tw-flex-wrap tw-gap-3 tw-items-center tw-justify-center tw-mb-6">
                  <img src="/icons/cards.svg" alt="Credit cards" />
                  <span class="tw-ml-3 tw-font-semibold tw-text-base">We accept Visa and Mastercard.</span>
                </div>
                <p class="tw-text-center tw-font-medium tw-mb-6 tw-max-w-lg">
                  Click the button below to be redirected to our secure payment gateway to enter your card details.
                </p>
                <div class="tw-text-center tw-mt-10">
                  <button
                      style="background-color: #114cac; min-width: 60%;"
                      class="tw-px-12 tw-py-3 tw-text-white tw-font-bold tw-shadow"
                      :disabled="loading"
                      @click="handleCardPayment">
                    <span v-if="!loading">Proceed with Card</span>
                    <span v-else>Processing...</span>
                  </button>
                </div>
              </div>
            </v-card>
          </div>
          <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8">
              <p class="c-blue-text tw-mt-4"><small>Note: The transaction name that will reflect in your statement is ‘APA Insurance’</small></p>
              <p class="c-gray-text tw-mt-4">For assistance: <span class="c-blue-text">0709912777</span></p>
            </div>
          </div>
        </div>
        <div v-else class="tw-w-full md:tw-w-8/12 tw-flex tw-justify-center tw-flex-col">
          <div>
            <div v-if="!notificationAllowed" class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-full tw-my-4 tw-flex tw-items-center tw-bg-blue-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-lg tw-border-blue-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <p>Allow Notifications to see receive important updates </p>
                <span class="tw-bg-blue-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-lg tw-text-sm tw-cursor-pointer" @click="requestNotification">ALLOW</span>
              </div>
            </div>

            <div v-if="notificationDenied" class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-full tw-my-4 tw-flex tw-items-center tw-bg-orange-200 tw-rounded-lg lg:tw-rounded-lg tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <p>Notifications BLOCKED! Allow Notifications to receive important updates, Go to site settings to allow </p>
              </div>
            </div>
          </div>
          <div v-if="paymentStatus === 'PENDING'" class="tw-flex tw-justify-center">
            <img class="tw-w-32 md:tw-w-40" src="/images/hourglass.gif" alt="loading">
          </div>
          <div class="tw-text-center">
            <h2 :class="[paymentStatus === 'FAILED' || paymentStatus === null ? 'tw-text-red-500' : 'tw-text-green-500' , 'tw-text-xl md:tw-text-3xl tw-mb-3']"> {{ paymentStatus === 'PENDING' ? 'Check your mobile for a payment request via MPESA' : paymentStatus === 'SUCCESSFUL' ? 'Payment Was Successful' : 'Payment Failed, Something went wrong!' }}</h2>
            <div v-if="paymentStatus === 'PENDING'">
              <p class="c-gray-text">Check your phone for MPESA payment request, <br> Enter your MPESA pin to complete the process
              </p>
              <p class="c-gray-text tw-mt-2">You will receive a notification on successful payment regarding your policy</p>
              <p class="c-gray-text tw-mt-2">This may take a few minutes</p>
              <p v-if="waiting" class="tw-mt-2 tw-text-blue-500">We're Almost there, Processing ....</p>
            </div>
          </div>
          <div v-if="!statusLoaded" class="tw-w-full lg:tw-w-3/4 tw-self-center tw-bg-orange-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
            <p>In case you did not receive the payment request on your mobile phone, <br>
              Kindly dial *234*1*6# to allow you to receive the payment request when transacting. <br> Refresh Page to retry
            </p>
          </div>
          <div v-if="statusLoaded" class="tw-w-full lg:tw-w-3/4 tw-self-center">
            <div v-if="paymentStatus === 'SUCCESSFUL'" class="tw-bg-green-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p v-if="scanObject(data.payment, 'description', '').includes('ext-')">Your Payment was received successfully.</p>
              <p v-else><strong>Your Payment was received successfully.</strong> <br>
                Your policy is currently being processed. You will receive a certificate on email. Please print and stick it on your car windscreen. Thank you for choosing us as your preferred insurer. APA, Insuring Happiness</p>

              <div class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
                <v-btn
                    :to="{name: 'MyPolicies'}"
                    color="secondary"
                >View My Policies</v-btn>
              </div>
            </div>
            <div v-if="paymentStatus === 'FAILED'" class="tw-bg-red-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p>Your Payment was NOT successful <br>  You'll be required to retry paying</p>
            </div>
          </div>

          <div v-if="paymentRetry || paymentStatus === 'FAILED'" class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
            <v-btn
                color="secondary"
                @click="paymentInitiated = false"
            >Retry payment Request</v-btn>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Cancelled Modal -->
    <div
      v-if="showCancelledModal"
      class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50">
      <div
        class="tw-bg-white tw-rounded-lg tw-p-6 sm:tw-p-8 tw-shadow-lg tw-text-center tw-w-11/12 sm:tw-max-w-md tw-max-w-full">
        <!-- Icon Section -->
        <div class="tw-flex tw-justify-center">
          <v-icon size="24" color="#FF6B6B" class="tw-text-5xl"
            >mdi-close-circle</v-icon
          >
        </div>

        <!-- Title Section -->
        <h2
          class="tw-text-xl sm:tw-text-2xl tw-font-bold tw-mt-4 tw-text-black">
          Payment Cancelled
        </h2>

        <!-- Description Section -->
        <p class="tw-text-gray-700 tw-my-4 tw-text-sm sm:tw-text-base">
          Your payment was cancelled. You can try again or contact us for assistance.
        </p>
        <p class="tw-text-gray-700 tw-text-sm sm:tw-text-base">
          For assistance, contact WhatsApp:
          <a
            href="https://wa.me/254115325445"
            class="tw-text-blue-600 hover:tw-underline"
            >0115 325 445</a
          >
        </p>

        <!-- Button Section -->
        <button
          @click="showCancelledModal = false"
          class="tw-bg-blue-600 tw-text-white tw-font-semibold tw-px-6 tw-py-3 tw-rounded-md tw-shadow-md tw-mt-6 hover:tw-bg-blue-700 tw-w-full sm:tw-w-auto">
          TRY AGAIN
        </button>
      </div>
    </div>

    <!-- Pesapal Payment Modal -->
    <PesapaliFrame
      :show-modal="showPesapalModal"
      :amount="data.payment.payableAmount"
      :redirect-url="pesapalRedirectUrl"
      @close="closePesapalModal" />
  </div>
</template>

<script>
/*eslint-disable*/
import CardTitle from '@/components/shared/CardTitle';
import BackNav from '@/components/buy/BackNav';
import axios from 'axios';
import {
  FB_BUY_PAYMENT_FAILURE,
  FB_BUY_PAYMENT_INIT,
  FB_BUY_PAYMENT_INIT_FAIL,
  FB_BUY_PAYMENT_PAYBILL,
  FB_BUY_PAYMENT_STK,
  FB_BUY_PAYMENT_SUCCESS,
} from '@/utils/const';
import { formatDateToMonth } from '@/utils/time';
import TopCard from '@/components/renew/TopCard';
import PremiumAmount from '@/components/buy/PremiumAmount';
import renewalMixin from '@/mixins/renewalMixin';
import paymentMixin from '@/mixins/paymentMixin';
import PesapaliFrame from '@/components/tpo/PesapaliFrame';
import { log } from '@/utils/errorLogger';

export default {
  name: 'MakePayment',
  props: ['data'],
  components: {
    PremiumAmount,
    TopCard,
    BackNav,
    CardTitle,
    PesapaliFrame,
  },
  mixins: [renewalMixin, paymentMixin],
  data() {
    return {
      currentTab: 'stk',
      form: {
        customerPhoneNumber: this.data.payment.customerPhoneNumber,
      },
      merchantRequestId: '',
      checkoutRequestId: '',
      paymentMethod: '',
      customerMessage: '',
      paymentResponse: '',
      transactionDetails: null,
      stkDetails: null,
      pesapalRedirectUrl: '',
      showPesapalModal: false,
      showCancelledModal: false,
    };
  },
  metaInfo: {
    title: 'Make Payment',
  },
  async mounted() {
    // Guard against missing data
    if (!this.data || !this.data.payment || !this.data.quoteInfo) {
      this.$toast.error('Payment data is missing. Please try again.');
      return;
    }

    this.form = this.data.payment;
    if (localStorage.getItem('distribution') === '100') { this.data.quoteInfo.payPercentage = 100; } else { this.data.quoteInfo.payPercentage = 40; }

    // Check for payment callback status from URL
    const { status, OrderTrackingId } = this.$route.query;

    if (status === 'success' && OrderTrackingId) {
      await this.validateCardPayment(OrderTrackingId);
    } else if (status === 'cancelled') {
      this.showCancelledModal = true;
      this.cleanupUrlParams();
    }
  },
  computed: {
    installments() {
      return this.scanObject(this.data, 'quoteInfo.coverType.riskPremDto.installments', []);
    },
    payableAmountPremium() {
      return this.data.payment.payableAmount;
    },
  },
  methods: {
    formatDateToMonth,
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    async createTransaction() {
      const paymentModes = {
        stk: 'MPESA_EXPRESS',
        paybil: 'MPESA_PAYBILL',
        card: 'CARD',
      };

      const renewalData = JSON.parse(localStorage.getItem('renewalData'));
      const formPayload = JSON.parse(localStorage.getItem('formPayload'));

      try {
        const payload = {
          agentId: null,
          renewal: true,
          policyNumber: this.$route.params.policyNo,
          type: 'renewal',
          vehicleReg: renewalData.regNo,
          amount: this.data.payment.payableAmount,
          customerId: formPayload.customerId,
          paymentMode: paymentModes[this.currentTab],
        };

        const response = await axios.post(
          `/motor/api/payment/transaction/create?cacheBust=${new Date().getTime()}`,
          payload,
        );

        if (response.data && response.data.code === 0) {
          this.transactionDetails = response.data.data;
          this.$toast.success('Transaction created successfully.');
        } else {
          throw new Error(
            response.data.message || 'Failed to create transaction.',
          );
        }
      } catch (error) {
        this.$toast.error(error.message || 'Error creating transaction.');
        throw error;
      }
    },
    async requestSTK() {
      this.loading = true;
      this.waiting = false;
      this.paymentRetry = false;
      this.paymentStatus = 'PENDING';

      try {
        await this.createTransaction();

        const payload = {
          accountReference: this.transactionDetails.orderId,
          customerPhoneNumber: this.form.customerPhoneNumber,
          description: 'Customer Portal frontend',
          kraPin: this.form.kraPin,
          payableAmount: this.data.payment.payableAmount,
          serviceType: 'MOTOR',
          transactionType: 'PAYMENT',
        };

        const response = await axios.post('/motor/api/payment/transaction/stk', payload);

        if (response.data.code === 0) {
          this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
          this.$toast.success('Request sent, check your phone to finish the process', 'Payment');
          this.paymentInitiated = true;
          this.checkoutRequestId = response.data.data.checkoutRequestId;
          this.merchantRequestId = response.data.data.merchantRequestId;
          this.customerMessage = response.data.data.customerMessage;
          this.paymentMethod = 'M-Pesa';
          this.paymentResponse = response.data.data.responseDescription;
          this.stkDetails = response.data.data;
          this.timeoutId = setTimeout(() => {
            this.checkPaymentStatus(response.data.data.checkoutRequestId);
          }, 15000);
        } else {
          this.$analytics.logEvent(FB_BUY_PAYMENT_INIT_FAIL);
          this.$toast.error('An Error occurred, please try again !', 'Payment');
        }
      } catch (error) {
        this.$toast.error('Payment flow failed');
      } finally {
        this.loading = false;
      }
    },
    checkPaymentStatus() {
      const payload = {
        customerId: this.data.quoteInfo.client.customerId,
        externalReference: '',
        message: this.customerMessage,
        mpesaAccountReference: JSON.parse(localStorage.getItem('renewalData')).vehicle.regNo.replace(/\s+/g, ''),
        mpesaRefOrCheckoutId: this.checkoutRequestId,
        orderId: this.transactionDetails.orderId,
        paymentMethod: this.paymentMethod,
        paymentResponse: this.paymentResponse,
        success: true,
        transactionRef: this.transactionDetails.transactionRef,
      };
      axios.post('/motor/api/payment/transaction/validation', payload)
        .then((resp) => {
          const code = resp.data.code;
          if (code === 0) {
            if (resp.data.data.success) {
              this.waiting = false;
              this.paymentStatus = 'SUCCESSFUL';
              this.$analytics.logEvent(FB_BUY_PAYMENT_STK);
              this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
            } else {
              this.paymentStatus = 'FAILED';
              this.paymentInitiated = true;
              this.paymentRetry = true;
              this.$toast.error(resp.data.data.message, 'payment');
              this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
            }
          } else {
            this.waiting = true;
            this.paymentStatus = 'PENDING';
            this.timeoutId = setTimeout(() => {
              this.checkPaymentStatus();
            }, 30000);
          }
          this.statusLoaded = true;
        });
    },
    async queryMpesaPaybill() {
      this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
      this.paybillLoading = true;

      try {
        await this.createTransaction();

        const payload = {
          customerId: this.data.quoteInfo.client.customerId,
          externalReference: '',
          message: this.customerMessage,
          mpesaAccountReference: this.getLocalStorageJson('renewalData').vehicle.regNo.replace(/\s+/g, ''),
          mpesaRefOrCheckoutId: this.mpesaRef,
          orderId: this.transactionDetails.orderId,
          paymentMethod: "Mobile",
          paymentResponse: "being processed",
          success: true,
          transactionRef: this.transactionDetails.transactionRef,
        };

        const resp = await axios.post('/motor/api/payment/transaction/validation', payload);
        const code = resp.data.code;

        if (code === 0) {
          if (resp.data.data.success) {
            this.statusLoaded = true;
            this.paymentStatus = 'SUCCESSFUL';
            this.$toast.success(resp.data.message, 'Payment');
            this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
            this.$analytics.logEvent(FB_BUY_PAYMENT_PAYBILL);
          } else {
            this.$toast.error(resp.data.data.message, 'Payment');
            this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
          }
        } else {
          this.$toast.error(resp.data.message, 'Payment');
          this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
        }
      } catch (error) {
        this.$toast.error('Paybill validation failed.');
        this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
      } finally {
        this.paybillLoading = false;
      }
    },
    async initiateCardPayment() {
      try {
        if (!this.transactionDetails || !this.transactionDetails.orderId) {
          throw new Error('Order ID is missing.');
        }

        const currentUrl = globalThis.location.href; // eslint-disable-line no-undef
        const separator = currentUrl.includes('?') ? '&' : '?';

        const payload = {
          orderId: this.transactionDetails.orderId,
          amount: this.data.payment.payableAmount,
          callbackUrl: `${currentUrl}${separator}status=success`,
          cancellationUrl: `${currentUrl}${separator}status=cancelled`,
        };

        const response = await axios.post(
          '/motor/api/payment/card/initiate',
          payload,
        );

        if (response.data && response.data.success && response.data.data) {
          const { redirectUrl } = response.data.data;
          if (!redirectUrl) {
            throw new Error('Redirect URL not received from payment gateway.');
          }
          this.pesapalRedirectUrl = redirectUrl;
        } else {
          throw new Error(response.data.msg || 'Failed to initiate card payment.');
        }
      } catch (error) {
        log(error, this, 'initiateCardPayment');
        this.$toast.error(error.message || 'Error initiating card payment.');
        throw error;
      }
    },
    async handleCardPayment() {
      this.loading = true;
      try {
        await this.createTransaction();
        await this.initiateCardPayment();
        this.showPesapalModal = true;
      } catch (error) {
        log(error, this, 'handleCardPayment');
        this.$toast.error('Failed to initiate card payment.');
      } finally {
        this.loading = false;
      }
    },
    closePesapalModal() {
      this.showPesapalModal = false;
    },
    async validateCardPayment(orderTrackingId, maxRetries = 30) {
      this.loading = true;
      let retries = 0;

      while (retries < maxRetries) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const response = await axios.get(
            `/motor/api/payment/card/validate/${orderTrackingId}`,
          );

          if (response.data?.data?.paymentStatusDescription) {
            const status = response.data.data.paymentStatusDescription.toLowerCase();

            if (status === 'completed') {
              this.loading = false;
              this.paymentStatus = 'SUCCESSFUL';
              this.statusLoaded = true;
              this.paymentInitiated = true;
              this.cleanupUrlParams();
              this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
              return;
            }

            if (status === 'failed' || status === 'invalid') {
              this.loading = false;
              this.showCancelledModal = true;
              this.cleanupUrlParams();
              this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
              return;
            }
          }
        } catch (error) {
          log(error, this, 'validateCardPayment');
        }

        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, 10000));
        retries += 1;
      }

      this.loading = false;
      this.paymentStatus = 'FAILED';
      this.statusLoaded = true;
      this.paymentInitiated = true;
      this.paymentRetry = true;
      this.cleanupUrlParams();
      this.$toast.error('Payment validation timed out. Please contact support.');
      this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
    },
    cleanupUrlParams() {
      const query = { ...this.$route.query };
      delete query.status;
      delete query.OrderTrackingId;
      delete query.OrderMerchantReference;
      this.$router.replace({ query });
    },
  },
};
</script>
<style scoped>
.payment-btn {
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.payment-btn-inactive {
  background-color: #F4F6F8;
  color: #374151;
}

.payment-btn-inactive:hover {
  background-color: #d6dae1;
  border-color: #2563eb;
}

.payment-btn-active {
  background-color: #114CAC;
  color: white;
  border-color: #114CAC;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
  transform: scale(1.02);
}
</style>
